import { createModel } from '@rematch/core';
import { DEFAULT_VALUE_0 } from 'common/config';
import { IRootModel } from 'app/store';
import { IEventListState, IEventState } from 'entities/Events/Event.models';
import { eventListReducers, eventReducers } from 'entities/Events/Event.reducers';
import { eventEffects, eventListEffects } from 'entities/Events/Event.effects';

export const eventList = createModel<IRootModel>()({
  state: {
    data: [],
    loading: true,
    count: DEFAULT_VALUE_0,
    watchUpdates: true,
  } as IEventListState,
  reducers: eventListReducers,
  effects: eventListEffects,
});

export const event = createModel<IRootModel>()({
  state: {
    data: null,
    loading: false,
    action: null,
    text: null,
    physicianId: null,
  } as IEventState,
  reducers: eventReducers,
  effects: eventEffects,
});
